
































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {DataTableHeader} from 'vuetify';
import {cloneDeep, isEqual} from 'lodash';
import Draggable from 'vuedraggable';

type Item = {
    item: {
        [key: string]: any;
    };
    initialItem: {
        [key: string]: any;
    };
};

@Component({
    inheritAttrs: false,
    components: {
        Draggable,
    },
})
export default class CTable extends Vue {
    @Prop() title!: string;
    @Prop({default: false, type: Boolean}) dense!: boolean;
    @Prop({default: true, type: Boolean}) editable!: boolean;
    @Prop({default: () => []}) headers!: DataTableHeader[];
    @Prop() value!: Array<{
        [key: string]: any;
    }>;
    @Prop() itemAddData!: {[key: string]: any};
    @Prop() onCopyFn!: (item: Item) => Item;
    @Prop() deleteBtnDisableFn!: () => void;
    @Prop({type: Boolean, default: false}) draggable!: boolean;
    @Prop() onDeleteAllFn!: (items: Array<Item>) => Array<Item>;

    private items: Array<Item> = [];

    get actualHeaders() {
        const draggableSlice = this.draggable
            ? [
                  {
                      text: '',
                      value: 'dragIcon',
                      sortable: false,
                      width: 50,
                  },
              ]
            : [];
        const actionsSlice = this.editable
            ? [
                  {
                      text: this.$t('Common.Actions'),
                      value: 'actions',
                      sortable: false,
                      width: 90,
                  },
              ]
            : [];
        const headers = this.headers.map(header => {
            return {
                ...header,
                value: `item.${header.value}`,
            };
        });
        return [...draggableSlice, ...headers, ...actionsSlice];
    }

    @Watch('items', {deep: true})
    onItemsChange(value: Array<Item>) {
        this.$emit(
            'input',
            value.map(item => item.item),
        );
    }

    @Watch('value', {deep: true})
    onValueChange(value: Array<{[key: string]: any}>, oldValue: any) {
        if (!isEqual(value, oldValue))
            this.items = value.map(item => {
                return {
                    item,
                    initialItem: cloneDeep(item),
                };
            });
    }

    created() {
        this.items = this.value.map(item => {
            return {
                item,
                initialItem: cloneDeep(item),
            };
        });
    }

    onAdd() {
        let item = cloneDeep(this.itemAddData);
        this.items.push({
            item,
            initialItem: cloneDeep(item),
        });
        this.$emit('input', this.items);
    }
    onDeleteAll() {
        if (this.onDeleteAllFn) {
            this.items = this.onDeleteAllFn(this.items);
        } else {
            this.items = [];
        }
        this.$emit('input', this.items);
    }
    onCopy(item: {[key: string]: any}) {
        let copyItem = this.onCopyFn ? cloneDeep(this.onCopyFn(item.item)) : cloneDeep(item.item);
        this.items.push({
            item: copyItem,
            initialItem: cloneDeep(copyItem),
        });
        this.$emit('input', this.items);
    }
    onDelete(item: {[key: string]: any}) {
        this.items = this.items.filter(el => el !== item);
        this.$emit('input', this.items);
    }
}
